<template>
    <ConfirmDialog :pt="passThrough">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div
                class="confirm-container"
                data-test-id="confirm-container"
            >
                <div class="confirm-content">
                    <p
                        v-if="message.header"
                        class="header"
                        data-test-id="confirm-header"
                    >
                        {{ message.header }}
                    </p>
                    <p
                        class="body"
                        data-test-id="confirm-message"
                    >
                        {{ message.message }}
                    </p>
                    <p
                        v-if="message.hint"
                        class="hint"
                        data-test-id="confirm-hint"
                    >
                        {{ message.hint }}
                    </p>
                </div>
                <div class="confirm-buttons">
                    <button
                        v-if="message.rejectLabel !== null"
                        class="btn"
                        type="button"
                        data-test-id="confirm-cancel"
                        @click="rejectCallback"
                    >
                        {{ message.rejectLabel || 'Cancel' }}
                    </button>
                    <button
                        class="btn btn-primary"
                        :class="{ warning: message.danger }"
                        type="button"
                        data-test-id="confirm-accept"
                        @click="acceptCallback"
                    >
                        {{ message.acceptLabel || 'Yes' }}
                    </button>
                </div>
            </div>
        </template>
    </ConfirmDialog>
</template>

<script>
import ConfirmDialog from 'primevue/confirmdialog'

/**
 * The application's confirmation modal, mounted once at the root. Anything
 * calling `confirm()` from the canConfirm mixin is answered here, so the
 * wording differs per prompt but the styling never does.
 */
export default {
    name: 'AppConfirmDialog',

    components: {
        ConfirmDialog,
    },

    data() {
        return {
            // The container slot supplies the whole dialog, so PrimeVue's own
            // chrome would only draw borders around it.
            passThrough: {
                root: { style: { border: 'none' } },
                header: { style: { border: 'none' } },
                content: { style: { border: 'none' } },
                footer: { style: { border: 'none' } },
            },
        }
    },
}
</script>

<style scoped lang="scss">
@use 'sass:color';

.confirm-container {
    width: 484px;
    max-width: 90vw;
    background-color: #2b2930;
    color: #f1f1f1;
    padding: 24px;
    border-radius: 8px;
    border-width: 0;

    .confirm-content {
        .header {
            font-size: 24px;
            font-family: 'Avenir', sans-serif;
            margin-bottom: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .body {
            margin-bottom: 16px;
            font-size: 16px;
            font-family: 'Avenir', sans-serif;
            white-space: pre-line;
        }

        // The secondary note some prompts add under the main question.
        .hint {
            margin-bottom: 24px;
            font-size: 14px;
            font-family: 'Avenir', sans-serif;
            opacity: 0.8;
        }
    }

    .confirm-buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-top: 12px;
        width: 100%;
        gap: 12px;

        .warning {
            background-color: #ffb3af;
            border-color: #ffb3af;
            color: #601410;

            &:not([disabled='disabled']):hover,
            &:not([disabled='disabled']):focus {
                background-color: color.adjust(#ffb3af, $lightness: 10%);
                border-color: color.adjust(#ffb3af, $lightness: 10%);
            }
        }
    }
}
</style>
